export default defineNuxtRouteMiddleware((to) => {
  if (to.path === '/clients' || to.path.startsWith('/clients/')) {
    const next = to.fullPath.replace(/^\/clients/, '/contacts/clients');
    if (next !== to.fullPath) {
      return navigateTo(next, { replace: true });
    }
  }
  if (to.path === '/partners' || to.path.startsWith('/partners/')) {
    const next = to.fullPath.replace(/^\/partners/, '/contacts/partners');
    if (next !== to.fullPath) {
      return navigateTo(next, { replace: true });
    }
  }
});
